import { ytVueGlobalStore } from "@/services/yt-vue-global-store";

const tabs = ytVueGlobalStore.instantGet('tabs');
export default {
  namespaced: true,
  state: {
    tabs: tabs || "",
  },
};
